import { toast, toastProps } from '@servicetitan/anvil2';
import { inject, injectable } from '@servicetitan/react-ioc';
import { AuthApi, UserPermissionType } from 'api';
import { action, makeObservable, observable, runInAction } from 'mobx';

@injectable()
export class BillingAccessStore {
    @observable isBillingEnabled = false;
    @observable loaded = false;

    constructor(@inject(AuthApi) private authApi: AuthApi) {
        makeObservable(this);
        this.loadBillingAccess();
    }
    @action async loadBillingAccess() {
        try {
            const billingEnabled = await this.authApi.client.checkPermission(
                UserPermissionType.Billing
            );
            runInAction(() => {
                this.isBillingEnabled = billingEnabled;
                this.loaded = true;
            });
        } catch {
            runInAction(() => {
                this.isBillingEnabled = true;
                this.loaded = true;
                toast.danger({
                    title: 'Failed to load user billing access. If this persists, please contact support.',
                    duration: 8000,
                } as toastProps);
            });
        }
    }
}
